/* AMS DIVISION v3 · POSTER WALL — commerce core (window.AMS). No dependencies. */
(() => {
  const d = document;
  const root = d.documentElement;
  const theme = window.theme || {};
  const R = theme.routes || {};
  const S = theme.strings || {};
  const cfg = theme.settings || {};
  const rootUrl = R.root || '/';

  const $ = (s, c = d) => c.querySelector(s);
  const $$ = (s, c = d) => Array.from(c.querySelectorAll(s));
  const motion = () => root.dataset.motion || 'full';
  const fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const emit = (name, detail) => d.dispatchEvent(new CustomEvent(name, { detail }));
  const parse = (html) => new DOMParser().parseFromString(html, 'text/html');
  const esc = (v) => String(v).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
  const fill = (str, map) => Object.keys(map).reduce((s, k) => s.split(`__${k}__`).join(map[k]), String(str || ''));
  const smooth = () => (motion() === 'full' ? 'smooth' : 'auto');
  const cssEsc = (v) => (window.CSS && CSS.escape ? CSS.escape(v) : String(v).replace(/["\\]/g, '\\$&'));

  /* ---------- money ---------- */
  const money = (cents) => {
    const value = Number(cents) / 100;
    const fmt = (n, dec, th, dp) => {
      const p = n.toFixed(dec).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return p.join(dp);
    };
    return String(theme.moneyFormat || '{{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount_no_decimals':
          return fmt(value, 0, ',', '.');
        case 'amount_with_comma_separator':
          return fmt(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator':
          return fmt(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator':
          return fmt(value, 2, "'", '.');
        default:
          return fmt(value, 2, ',', '.');
      }
    });
  };

  /* ---------- live region ---------- */
  const announce = (text) => {
    const el = $('#AmsLive');
    if (!el || !text) return;
    el.textContent = '';
    requestAnimationFrame(() => (el.textContent = text));
  };

  /* Button label "Main · twin" → main line plus the plain-language twin. */
  const labelHtml = (text) => {
    const m = String(text || '').match(/^(.*?)\s([·–—])\s(.*)$/);
    return m ? `<span>${esc(m[1])}</span> <span class="btn__twin">${m[2]} ${esc(m[3])}</span>` : `<span>${esc(text || '')}</span>`;
  };

  /* ---------- layers (drawer, menu, search) ---------- */
  const openLayers = [];
  const focusables = (el) =>
    $$('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])', el).filter(
      (n) => n.offsetParent !== null || n === d.activeElement
    );

  const openLayer = (layer, focusEl) => {
    if (!layer) return;
    if (!layer.hidden && layer.classList.contains('is-open')) return;
    layer._return = d.activeElement;
    layer.hidden = false;
    d.body.classList.add('has-overlay');
    d.body.style.overflow = 'hidden';
    /* A layer rendered inside a sticky section (menu drawer) must escape that stacking context. */
    const host = layer.closest('.shopify-section');
    if (host) host.classList.add('is-layer-open');
    requestAnimationFrame(() => requestAnimationFrame(() => layer.classList.add('is-open')));
    if (!openLayers.includes(layer)) openLayers.push(layer);
    setTimeout(() => {
      const t = focusEl || focusables(layer)[0];
      if (t) t.focus({ preventScroll: true });
    }, motion() === 'full' ? 320 : 20);
  };

  const closeLayer = (layer) => {
    if (!layer || layer.hidden) return;
    layer.classList.remove('is-open');
    const at = openLayers.indexOf(layer);
    if (at > -1) openLayers.splice(at, 1);
    if (!openLayers.length) {
      d.body.classList.remove('has-overlay');
      d.body.style.overflow = '';
    }
    setTimeout(() => {
      if (layer.classList.contains('is-open')) return;
      layer.hidden = true;
      const host = layer.closest('.shopify-section');
      if (host) host.classList.remove('is-layer-open');
    }, motion() === 'full' ? 600 : 20);
    if (layer._return && layer._return.isConnected) layer._return.focus({ preventScroll: true });
  };

  const drawer = () => $('[data-cart-drawer]');

  const initLayers = () => {
    d.addEventListener('click', (e) => {
      const t = e.target;
      const menuOpen = t.closest('[data-menu-open]');
      if (menuOpen) {
        menuOpen.setAttribute('aria-expanded', 'true');
        openLayer($('#MenuDrawer'));
        return;
      }
      if (t.closest('[data-menu-close]')) {
        $$('[data-menu-open]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
        closeLayer($('#MenuDrawer'));
        return;
      }
      if (t.closest('[data-search-open]')) {
        openLayer($('#SearchOverlay'), $('#SearchOverlayInput'));
        return;
      }
      if (t.closest('[data-search-close]')) {
        closeLayer($('#SearchOverlay'));
        return;
      }
      if (t.closest('[data-cart-toggle]') && drawer()) {
        e.preventDefault();
        openLayer(drawer());
        return;
      }
      if (t.closest('[data-cart-close]')) closeLayer(drawer());
    });

    d.addEventListener('keydown', (e) => {
      const top = openLayers[openLayers.length - 1];
      if (e.key === 'Escape') {
        if (top) closeLayer(top);
        $$('details[open][data-close-outside], details[open][data-hover-details]').forEach((x) => x.removeAttribute('open'));
        return;
      }
      if (e.key !== 'Tab' || !top) return;
      const f = focusables(top);
      if (!f.length) return;
      const first = f[0];
      const last = f[f.length - 1];
      if (e.shiftKey && (d.activeElement === first || !top.contains(d.activeElement))) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && (d.activeElement === last || !top.contains(d.activeElement))) {
        e.preventDefault();
        first.focus();
      }
    });
  };

  /* ---------- header: hide on scroll down, --header-h ---------- */
  const getHeader = () => $('[data-header]');
  let lastY = window.scrollY;
  const setHeaderH = () => {
    const h = getHeader();
    if (h) root.style.setProperty('--header-h', `${h.offsetHeight}px`);
  };
  const updateHeader = () => {
    const h = getHeader();
    if (!h) return;
    const y = window.scrollY;
    h.classList.toggle('is-scrolled', y > 40);
    const wrap = h.closest('.section-header') || h.closest('.shopify-section');
    if (h.dataset.sticky === 'true' && wrap) {
      const busy = d.body.classList.contains('has-overlay') || h.classList.contains('is-mega-open');
      wrap.classList.toggle('is-hidden', y > lastY && y > 300 && !busy);
    }
    lastY = y;
  };
  let ticking = false;
  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      updateHeader();
      ticking = false;
    });
  };

  const bindHover = (scope = d) => {
    if (!fine) return;
    $$('[data-hover-details]', scope).forEach((det) => {
      if (det.dataset.hoverReady) return;
      det.dataset.hoverReady = '1';
      {
        const item = det.parentElement;
        let timer;
        item.addEventListener('mouseenter', () => {
          clearTimeout(timer);
          det.setAttribute('open', '');
        });
        item.addEventListener('mouseleave', () => {
          timer = setTimeout(() => det.removeAttribute('open'), 150);
        });
      }
    });
  };

  const initDetails = () => {
    bindHover(d);
    d.addEventListener('click', (e) => {
      $$('details[open][data-close-outside], details[open][data-hover-details]').forEach((det) => {
        if (!det.contains(e.target)) det.removeAttribute('open');
      });
    });
  };

  const initMega = () => {
    d.addEventListener(
      'toggle',
      (e) => {
        if (!e.target.matches || !e.target.matches('.mega')) return;
        const h = getHeader();
        if (h) h.classList.toggle('is-mega-open', Boolean($('.mega[open]', h)));
      },
      true
    );
  };

  /* ---------- predictive search: mini flyers ---------- */
  const renderPredictive = (box, data, q) => {
    const results = (data && data.resources && data.resources.results) || {};
    const products = results.products || [];
    const colls = results.collections || [];
    if (!products.length && !colls.length) {
      box.innerHTML = `<p class="predictive__empty">${esc(S.searchNoResults || '')} “${esc(q)}”</p>`;
      return;
    }
    const items = products
      .map((p, i) => {
        const img = (p.featured_image && p.featured_image.url) || p.image;
        const price = Math.round(parseFloat(p.price) * 100);
        return `<a href="${esc(p.url)}" class="predictive__item" style="--i:${i}"><span class="predictive__media">${
          img ? `<img src="${esc(img)}${img.includes('?') ? '&' : '?'}width=400" alt="" loading="lazy">` : ''
        }</span><span class="predictive__title">${esc(p.title)}</span><span class="predictive__price t-mono">${esc(money(price))}</span></a>`;
      })
      .join('');
    const url = `${R.search}?q=${encodeURIComponent(q)}&type=product`;
    const tapes = colls.length
      ? `<div class="predictive__colls">${colls
          .slice(0, 4)
          .map((c) => `<a class="tape" href="${esc(c.url)}">${esc(c.title)}</a>`)
          .join('')}</div>`
      : '';
    box.innerHTML = `${tapes}${items ? `<div class="predictive">${items}</div>` : ''}<a class="link-arrow predictive__all" href="${url}">${esc(S.searchViewAll || '')} →</a>`;
  };

  const initPredictive = () => {
    const input = $('[data-predictive-input]');
    const box = $('[data-predictive-results]');
    if (!input || !box || !R.predictiveSearch) return;
    let timer;
    let ctrl;
    input.addEventListener('input', () => {
      const q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) {
        box.innerHTML = '';
        return;
      }
      timer = setTimeout(() => {
        if (ctrl) ctrl.abort();
        ctrl = new AbortController();
        fetch(
          `${R.predictiveSearch}.json?q=${encodeURIComponent(q)}&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last`,
          { signal: ctrl.signal }
        )
          .then((r) => r.json())
          .then((data) => renderPredictive(box, data, q))
          .catch(() => {});
      }, 220);
    });
  };

  /* ---------- cart: the pocket ---------- */
  const updateCount = (count) => {
    const n = Number(count) || 0;
    $$('[data-cart-count]').forEach((b) => {
      b.textContent = n;
      b.classList.toggle('is-empty', n === 0);
      b.classList.remove('is-bumped');
      void b.offsetWidth;
      b.classList.add('is-bumped');
    });
    if (S.cartCount) $$('[data-pocket-icon]').forEach((a) => a.setAttribute('aria-label', fill(S.cartCount, { COUNT: n })));
  };

  const renderDrawer = (html) => {
    const dr = drawer();
    if (!dr || !html) return;
    const fresh = parse(html).querySelector('[data-cart-inner]');
    const cur = $('[data-cart-inner]', dr);
    if (!fresh || !cur) return;
    const active = d.activeElement;
    const hadFocus = active && cur.contains(active);
    let key = null;
    let idx = -1;
    if (hadFocus) {
      const line = active.closest('[data-line-key]');
      if (line) {
        key = line.dataset.lineKey;
        idx = $$('button, input', line).indexOf(active);
      }
    }
    const node = d.importNode(fresh, true);
    cur.replaceWith(node);
    updateCount(node.dataset.count);
    if (window.Wall && typeof window.Wall.init === 'function') window.Wall.init(node);
    if (hadFocus) {
      const line = key && $(`[data-line-key="${cssEsc(key)}"]`, node);
      const target = (line && $$('button, input', line)[idx]) || $('[data-cart-close]', node);
      if (target) target.focus({ preventScroll: true });
    }
  };

  const cartRequest = (url, body) =>
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(async (res) => {
      const data = await res.json().catch(() => ({}));
      if (!res.ok || data.status) throw Object.assign(data, { httpStatus: res.status });
      return data;
    });

  const afterAdd = () => {
    const dr = drawer();
    if (!dr || cfg.pocketOpensDrawer === false) return;
    setTimeout(() => openLayer(dr), motion() === 'full' ? 360 : 0);
  };

  const cart = {
    get: () => fetch(`${rootUrl}cart.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json()),

    add(items, { source } = {}) {
      emit('cart:add-start', { items, source });
      const dr = drawer();
      const body = { items };
      if (dr) {
        body.sections = 'cart-drawer';
        body.sections_url = window.location.pathname;
      }
      return cartRequest(`${R.cartAdd}.js`, body).then(
        (data) => {
          if (!dr) {
            window.location.href = R.cart;
            return data;
          }
          renderDrawer(data.sections && data.sections['cart-drawer']);
          emit('cart:updated', { data, items, source });
          afterAdd();
          return data;
        },
        (error) => {
          emit('cart:error', { error, source });
          throw error;
        }
      );
    },

    addEach(items, { source } = {}) {
      emit('cart:add-start', { items, source });
      const one = (list) => cartRequest(`${R.cartAdd}.js`, { items: list });
      return one(items)
        .then(
          () => ({ added: items.slice(), failed: [] }),
          async () => {
            const added = [];
            const failed = [];
            for (const item of items) {
              try {
                await one([item]);
                added.push(item);
              } catch (error) {
                failed.push({ item, error });
              }
            }
            return { added, failed };
          }
        )
        .then(async (result) => {
          if (!result.added.length) {
            emit('cart:error', { error: result.failed[0] && result.failed[0].error, source });
            return result;
          }
          if (!drawer()) {
            window.location.href = R.cart;
            return result;
          }
          const html = await fetch(`${rootUrl}?section_id=cart-drawer`)
            .then((r) => r.text())
            .catch(() => '');
          renderDrawer(html);
          emit('cart:updated', { data: result, items: result.added, source });
          afterAdd();
          return result;
        });
    },

    change(key, quantity) {
      return cartRequest(`${R.cartChange}.js`, {
        id: key,
        quantity,
        sections: 'cart-drawer',
        sections_url: window.location.pathname
      }).then((data) => {
        renderDrawer(data.sections && data.sections['cart-drawer']);
        emit('cart:updated', { data, items: [], source: null });
        if (Number(quantity) === 0) announce(S.removedSr);
        if (d.body.classList.contains('template-cart')) window.location.reload();
        return data;
      });
    }
  };

  const setLoading = (btn, on) => {
    if (!btn) return;
    btn.classList.toggle('is-loading', on);
    btn.setAttribute('aria-busy', String(on));
    if (on) {
      btn._wasDisabled = btn.disabled;
      btn.disabled = true;
    } else {
      btn.disabled = Boolean(btn._wasDisabled);
    }
  };

  /* ---------- the fringe guard ---------- */
  const fringeOf = (scope) => $$('[data-fringe]', scope).find((f) => f.tagName === 'FIELDSET');

  const guard = (form) => {
    const fr = fringeOf(form);
    if (!fr || fr.querySelector('.fringe__input:checked')) return true;
    fr.classList.add('is-invalid');
    const first = $('.fringe__input', fr);
    if (first) {
      fr.scrollIntoView({ block: 'center', behavior: smooth() });
      first.focus({ preventScroll: true });
    }
    announce(S.chooseSize);
    return false;
  };

  const goNotify = (scope) => {
    const section = scope.closest('[data-product-section]') || scope;
    const box = $('[data-notify]', section);
    if (!box) return;
    box.hidden = false;
    box.scrollIntoView({ block: 'center', behavior: smooth() });
    const email = $('[data-notify-email]', box) || focusables(box)[0];
    if (email) email.focus({ preventScroll: true });
  };

  const initCart = () => {
    d.addEventListener('submit', (e) => {
      const form = e.target.closest && e.target.closest('form[data-product-form]');
      if (!form) return;
      e.preventDefault();
      if (!guard(form)) return;
      const btn = $('[data-add-button]', form);
      if (btn && btn.dataset.mode === 'notify') {
        goNotify(form);
        return;
      }
      const fd = new FormData(form);
      const id = Number(fd.get('id'));
      if (!id) return;
      const quantity = Math.max(1, Number(fd.get('quantity')) || 1);
      const err = $('[data-form-error]', form);
      if (err) err.hidden = true;
      setLoading(btn, true);
      cart
        .add([{ id, quantity }], { source: form })
        .catch((error) => {
          const msg = (error && (error.description || error.message)) || S.cartError;
          if (err) {
            err.textContent = msg;
            err.hidden = false;
          }
          announce(msg);
        })
        .finally(() => setLoading(btn, false));
    });

    /* Required strips: replace the native bubble with the torn-strip guard. */
    d.addEventListener(
      'invalid',
      (e) => {
        const input = e.target;
        if (!input.matches || !input.matches('.fringe__input')) return;
        e.preventDefault();
        const form = input.form || input.closest('form');
        if (!form || form._guarding) return;
        form._guarding = true;
        requestAnimationFrame(() => (form._guarding = false));
        guard(form);
      },
      true
    );

    d.addEventListener('change', (e) => {
      const t = e.target;
      const fr = t.closest && t.closest('[data-fringe]');
      if (fr) fr.classList.remove('is-invalid');
      const q = t.closest && t.closest('[data-qty-input]');
      if (q) {
        const line = q.closest('[data-line-key]');
        if (line) changeLine(line, Math.max(0, parseInt(q.value, 10) || 0));
        return;
      }
      if (t.matches && t.matches('[data-cart-note]') && R.cartUpdate) {
        cartRequest(`${R.cartUpdate}.js`, { note: t.value }).catch(() => {});
      }
    });

    d.addEventListener('click', (e) => {
      const change = e.target.closest('[data-qty-change]');
      if (!change) return;
      const line = change.closest('[data-line-key]');
      if (!line) return;
      e.preventDefault();
      changeLine(line, Number(change.dataset.qtyChange));
    });
  };

  const changeLine = (line, qty) => {
    line.classList.add('is-updating');
    const old = $('.cart-line__error', line);
    if (old) old.remove();
    cart.change(line.dataset.lineKey, qty).catch((error) => {
      line.classList.remove('is-updating');
      const msg = (error && (error.description || error.message)) || S.cartError;
      const p = d.createElement('p');
      p.className = 'cart-line__error t-small';
      p.setAttribute('role', 'alert');
      p.textContent = msg;
      line.appendChild(p);
    });
  };

  /* ---------- product: fringe morph, torn state, notify, sticky ---------- */
  const sizeText = (input) => {
    const l = input && input.labels && input.labels[0];
    const s = l && $('.fringe__size', l);
    return s ? s.textContent.trim() : (input && input.dataset.size) || '';
  };

  const setUrlVariant = (section, id) => {
    if (!id || section.closest('[data-quick-view-dialog]')) return;
    const u = new URL(window.location.href);
    u.searchParams.set('variant', id);
    window.history.replaceState(window.history.state, '', u.toString());
  };

  const applyState = (section) => {
    const fr = fringeOf(section);
    const checked = fr && $('.fringe__input:checked', fr);
    const torn = !fr || Boolean(checked);
    const btn = $('[data-add-button]', section);
    const available = checked && checked.name === 'id' ? checked.dataset.available === 'true' : !btn || btn.dataset.available !== 'false';
    const mode = !torn ? 'choose' : available ? 'pocket' : 'notify';
    section.dataset.buyMode = mode;

    if (btn && !btn.classList.contains('is-loading')) {
      btn.disabled = false;
      btn.removeAttribute('aria-disabled');
      delete btn.dataset.mode;
      if (mode === 'choose') btn.setAttribute('aria-disabled', 'true');
      if (mode === 'notify') btn.dataset.mode = 'notify';
      const label = $('[data-add-label]', btn);
      const text = mode === 'choose' ? S.chooseSize : mode === 'notify' ? `${S.notifyMe} · ${S.soldOut}` : S.pocketIt;
      if (label) label.innerHTML = labelHtml(text);
    }

    const size = checked ? sizeText(checked) : '';
    if (fr) {
      const sel = $('[data-fringe-selected]', fr);
      if (sel) sel.textContent = checked ? fill(S.selected, { VALUE: size }) : S.chooseSizeShort;
    }

    const box = $('[data-notify]', section);
    if (box) {
      box.hidden = !(mode === 'notify' || $('[data-notify-sent]', box));
      const body = $('[data-notify-body]', box);
      if (body && checked && checked.name === 'id') body.value = `${box.dataset.notifyProduct || ''} – ${size}`;
    }

    const dyn = $('[data-pdp-dynamic]', section);
    if (dyn) dyn.hidden = mode !== 'pocket';

    const bar = $('[data-sticky-buy]', section);
    if (bar) {
      const sb = $('[data-sticky-button]', bar);
      const sc = $('[data-sticky-choose]', bar);
      const ss = $('[data-sticky-size]', bar);
      if (sb) {
        sb.hidden = !torn;
        const sl = $('[data-sticky-label]', sb);
        if (sl) sl.textContent = mode === 'notify' ? S.notifyMe : String(S.pocketIt || '').split(' · ')[0];
      }
      if (sc) sc.hidden = torn;
      if (ss) {
        ss.textContent = size;
        ss.hidden = !size;
      }
    }
  };

  /* In-place morph of [data-variant-picker]: never replace focused nodes. */
  const morph = (cur, fresh) => {
    if (!cur || !fresh) return;
    const ci = $$('input', cur);
    const fi = $$('input', fresh);
    const active = d.activeElement;
    const fs = active && cur.contains(active) ? active.closest('fieldset') : null;
    const fsIndex = fs ? $$('fieldset', cur).indexOf(fs) : -1;
    const same = ci.length === fi.length && fi.every((f, i) => ci[i].id === f.id);
    if (!same) {
      cur.innerHTML = fresh.innerHTML;
    } else {
      fi.forEach((f, i) => {
        const c = ci[i];
        c.checked = f.checked;
        if (c.value !== f.value) c.value = f.value;
        ['available', 'variantIds'].forEach((k) => {
          if (f.dataset[k] != null) c.dataset[k] = f.dataset[k];
        });
        const fl = $(`label[for="${cssEsc(f.id)}"]`, fresh);
        const cl = $(`label[for="${cssEsc(c.id)}"]`, cur);
        if (!fl || !cl) return;
        const keep = ['is-yours', 'is-pocketed'].filter((k) => cl.classList.contains(k));
        cl.className = fl.className;
        keep.forEach((k) => cl.classList.add(k));
        cl.setAttribute('style', fl.getAttribute('style') || '');
        if (fl.dataset.variantIds != null) cl.dataset.variantIds = fl.dataset.variantIds;
        if (cl.innerHTML !== fl.innerHTML) cl.innerHTML = fl.innerHTML;
      });
      const fsel = $$('[data-fringe-selected]', fresh);
      $$('[data-fringe-selected]', cur).forEach((el, i) => {
        if (fsel[i]) el.textContent = fsel[i].textContent;
      });
    }
    if (fsIndex >= 0) {
      const nfs = $$('fieldset', cur)[fsIndex];
      const t = nfs && ($('input:checked', nfs) || $('input', nfs));
      if (t && d.activeElement !== t) t.focus({ preventScroll: true });
    }
  };

  const refresh = (section) => {
    const picker = $('[data-variant-picker]', section);
    if (!picker) return;
    const ids = $$('fieldset', picker)
      .map((f) => {
        const c = $('input[data-option-value-id]:checked', f) || (f.matches('[data-fringe]') ? $('input[data-option-value-id]', f) : null);
        return c && c.dataset.optionValueId;
      })
      .filter(Boolean);
    if (section._ctrl) section._ctrl.abort();
    const ctrl = (section._ctrl = new AbortController());
    section.classList.add('is-updating');
    fetch(`${section.dataset.productUrl}?section_id=${section.dataset.sectionId}&option_values=${ids.join(',')}`, { signal: ctrl.signal })
      .then((r) => r.text())
      .then((html) => {
        const fresh = parse(html).querySelector('[data-product-section]');
        if (!fresh) return;
        morph(picker, $('[data-variant-picker]', fresh));
        if (!section.dataset.torn) {
          const fr = fringeOf(section);
          if (fr) $$('.fringe__input', fr).forEach((i) => (i.checked = false));
        }
        ['[data-product-price]', '[data-sticky-price]'].forEach((sel) => {
          const a = $(sel, fresh);
          const b = $(sel, section);
          if (a && b) b.innerHTML = a.innerHTML;
        });
        const fb = $('[data-add-button]', fresh);
        const b = $('[data-add-button]', section);
        if (fb && b) b.dataset.available = fb.dataset.available;
        const fv = $('[data-variant-id]', fresh);
        const v = $('[data-variant-id]', section);
        if (fv && v) {
          v.value = fv.value;
          if (section.dataset.torn) setUrlVariant(section, fv.value);
        }
        const fnb = $('[data-notify-body]', fresh);
        const nb = $('[data-notify-body]', section);
        if (fnb && nb && !(fringeOf(section) && $('.fringe__input[name="id"]', section))) nb.value = fnb.value;
        applyState(section);
        const act = $('.pdp__media.is-active', fresh);
        const target = act && $(`[data-media-id="${cssEsc(act.dataset.mediaId)}"]`, section);
        if (target && !target.classList.contains('is-active')) {
          $$('.pdp__media', section).forEach((m) => m.classList.toggle('is-active', m === target));
          const track = $('[data-gallery-track]', section);
          if (track && track.scrollWidth > track.clientWidth + 4) track.scrollTo({ left: target.offsetLeft - track.offsetLeft, behavior: smooth() });
          else if (target !== $('.pdp__media', section)) target.scrollIntoView({ behavior: smooth(), block: 'center' });
        }
        if (window.Wall && typeof window.Wall.init === 'function') window.Wall.init(picker);
      })
      .catch(() => {})
      .finally(() => {
        if (section._ctrl === ctrl) section.classList.remove('is-updating');
      });
  };

  const initSticky = (section) => {
    const bar = $('[data-sticky-buy]', section);
    const btn = $('.pdp__info [data-add-button]', section) || $('[data-add-button]', section);
    if (!bar || !btn || !('IntersectionObserver' in window)) return;
    let past = false;
    let atFoot = false;
    const update = () => {
      const vis = past && !atFoot;
      bar.classList.toggle('is-visible', vis);
      bar.setAttribute('aria-hidden', String(!vis));
      $$('button', bar).forEach((b) => (b.tabIndex = vis ? 0 : -1));
    };
    let queued = false;
    const check = () => {
      queued = false;
      past = btn.getBoundingClientRect().bottom < 0;
      update();
    };
    window.addEventListener(
      'scroll',
      () => {
        if (queued) return;
        queued = true;
        requestAnimationFrame(check);
      },
      { passive: true }
    );
    check();
    const foot = $('.section-footer') || $('footer');
    if (foot)
      new IntersectionObserver(([en]) => {
        atFoot = en.isIntersecting;
        update();
      }).observe(foot);
  };

  const initProduct = (scope = d) => {
    const list = scope.matches && scope.matches('[data-product-section]') ? [scope] : $$('[data-product-section]', scope);
    list.forEach((section) => {
      if (section.dataset.productReady) return;
      section.dataset.productReady = '1';
      const fr = fringeOf(section);
      if (!fr || $('.fringe__input:checked', fr)) section.dataset.torn = '1';
      applyState(section);

      section.addEventListener('change', (e) => {
        const input = e.target;
        if (!input.matches('[data-option-value-id]')) return;
        if (input.closest('[data-fringe]')) section.dataset.torn = '1';
        applyState(section);
        if (input.name === 'id' && input.checked) setUrlVariant(section, input.value);
        refresh(section);
      });

      section.addEventListener('click', (e) => {
        if (!e.target.closest('[data-sticky-choose]')) return;
        const f = fringeOf(section);
        if (!f) return;
        f.scrollIntoView({ block: 'center', behavior: smooth() });
        const t = $('.fringe__input:checked', f) || $('.fringe__input', f);
        if (t) t.focus({ preventScroll: true });
      });

      const track = $('[data-gallery-track]', section);
      const counter = $('[data-gallery-current]', section);
      if (track && counter) {
        track.addEventListener(
          'scroll',
          () => {
            counter.textContent = Math.round(track.scrollLeft / Math.max(1, track.clientWidth)) + 1;
          },
          { passive: true }
        );
      }
      if (!section.closest('[data-quick-view-dialog]')) initSticky(section);
      if ($('[data-notify-sent]', section)) goNotify(section);
    });
  };

  /* ---------- quick view "Flip" ---------- */
  const qvDialog = () => $('[data-quick-view-dialog]');
  const quickView = (url, trigger) => {
    const dialog = qvDialog();
    if (!dialog || typeof dialog.showModal !== 'function') {
      window.location.href = url;
      return;
    }
    const content = $('[data-quick-view-content]', dialog);
    dialog._trigger = trigger || d.activeElement;
    content.classList.remove('is-flipping');
    content.innerHTML = `<p class="t-mono">${esc(S.loading || '')}</p>`;
    if (!dialog.open) dialog.showModal();
    fetch(`${url}${url.includes('?') ? '&' : '?'}section_id=quick-view`)
      .then((r) => r.text())
      .then((html) => {
        const view = parse(html).querySelector('.quick-view');
        if (!view) {
          window.location.href = url;
          return;
        }
        content.replaceChildren(d.importNode(view, true));
        initProduct(content);
        if (window.Wall && typeof window.Wall.init === 'function') window.Wall.init(content);
        if (motion() === 'full') {
          void content.offsetWidth;
          content.classList.add('is-flipping');
          setTimeout(() => content.classList.remove('is-flipping'), 420);
        }
        const title = $('.quick-view__title', content);
        if (title) {
          title.tabIndex = -1;
          title.focus({ preventScroll: true });
        }
      })
      .catch(() => {
        window.location.href = url;
      });
  };

  const initQuickView = () => {
    const dialog = qvDialog();
    d.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-quick-view]');
      if (!trigger) return;
      e.preventDefault();
      quickView(trigger.dataset.quickView, trigger);
    });
    if (!dialog) return;
    dialog.addEventListener('close', () => {
      const t = dialog._trigger;
      dialog._trigger = null;
      const content = $('[data-quick-view-content]', dialog);
      if (content) content.replaceChildren();
      if (t && t.isConnected) t.focus({ preventScroll: true });
    });
    d.addEventListener('cart:updated', () => {
      if (dialog.open) dialog.close();
    });
  };

  /* ---------- modals, lightbox ---------- */
  const initModals = () => {
    d.addEventListener('click', (e) => {
      const opener = e.target.closest('[data-modal-open]');
      if (opener) {
        const m = d.getElementById(opener.dataset.modalOpen);
        if (m && typeof m.showModal === 'function') m.showModal();
        return;
      }
      const closer = e.target.closest('[data-modal-close]');
      if (closer) {
        const dlg = closer.closest('dialog');
        if (dlg) dlg.close();
        return;
      }
      if (e.target.tagName === 'DIALOG') e.target.close();
    });
  };

  const zoomOrigin = (img, e) => {
    const r = img.parentElement.getBoundingClientRect();
    img.style.transformOrigin = `${(((e.clientX - r.left) / r.width) * 100).toFixed(1)}% ${(((e.clientY - r.top) / r.height) * 100).toFixed(1)}%`;
  };

  const initLightbox = () => {
    d.addEventListener('click', (e) => {
      const opener = e.target.closest('[data-zoom-open]');
      if (opener) {
        const section = opener.closest('[data-product-section]');
        const lb = section && d.getElementById(`Lightbox-${section.dataset.sectionId}`);
        if (!lb || typeof lb.showModal !== 'function') return;
        lb.showModal();
        const track = $('[data-lightbox-track]', lb);
        track.scrollTo({ left: track.clientWidth * Number(opener.dataset.zoomOpen), behavior: 'instant' });
        return;
      }
      const lb = e.target.closest('[data-lightbox]');
      if (!lb) return;
      const track = $('[data-lightbox-track]', lb);
      if (e.target.closest('[data-lightbox-next]')) return track.scrollBy({ left: track.clientWidth, behavior: smooth() });
      if (e.target.closest('[data-lightbox-prev]')) return track.scrollBy({ left: -track.clientWidth, behavior: smooth() });
      const img = e.target.closest('[data-lightbox-image]');
      if (img) {
        zoomOrigin(img, e);
        img.classList.toggle('is-zoomed');
        track.style.overflowX = img.classList.contains('is-zoomed') ? 'hidden' : '';
      }
    });
    bindLightboxes(d);
  };

  const bindLightboxes = (scope) => {
    $$('[data-lightbox]', scope).forEach((lb) => {
      if (lb.dataset.ready) return;
      lb.dataset.ready = '1';
      const track = $('[data-lightbox-track]', lb);
      const cur = $('[data-lightbox-current]', lb);
      track.addEventListener('scroll', () => cur && (cur.textContent = Math.round(track.scrollLeft / Math.max(1, track.clientWidth)) + 1), {
        passive: true
      });
      lb.addEventListener('pointermove', (e) => {
        const img = e.target.closest('[data-lightbox-image].is-zoomed');
        if (img) zoomOrigin(img, e);
      });
      lb.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') track.scrollBy({ left: track.clientWidth, behavior: smooth() });
        if (e.key === 'ArrowLeft') track.scrollBy({ left: -track.clientWidth, behavior: smooth() });
      });
      lb.addEventListener('close', () => {
        $$('[data-lightbox-image].is-zoomed', lb).forEach((i) => i.classList.remove('is-zoomed'));
        track.style.overflowX = '';
      });
    });
  };

  /* ---------- recommendations ---------- */
  const initRecommendations = (scope = d) => {
    $$('[data-recommendations]', scope).forEach((section) => {
      if (section.dataset.loaded || !section.dataset.url) return;
      const load = () => {
        section.dataset.loaded = '1';
        fetch(section.dataset.url)
          .then((r) => r.text())
          .then((html) => {
            const fresh = parse(html).querySelector('[data-recommendations]');
            if (!fresh || !fresh.innerHTML.trim()) return;
            section.innerHTML = fresh.innerHTML;
            if (window.Wall && typeof window.Wall.init === 'function') window.Wall.init(section);
          })
          .catch(() => {});
      };
      if (!('IntersectionObserver' in window)) return load();
      const io = new IntersectionObserver(
        (en) => {
          if (!en[0].isIntersecting) return;
          io.disconnect();
          load();
        },
        { rootMargin: '0px 0px 400px 0px' }
      );
      io.observe(section);
    });
  };

  /* ---------- filters, account ---------- */
  const initAutosubmit = () => {
    const go = (form) => {
      const params = new URLSearchParams(new FormData(form));
      Array.from(params.entries()).forEach(([k, v]) => v === '' && params.delete(k));
      window.location.search = params.toString();
    };
    d.addEventListener('change', (e) => {
      const field = e.target.closest && e.target.closest('[data-autosubmit]');
      if (!field || !field.form) return;
      if (field.form.matches('[data-filter-form]')) return go(field.form);
      if (field.form.requestSubmit) field.form.requestSubmit();
      else field.form.submit();
    });
    d.addEventListener('submit', (e) => {
      if (!e.target.matches || !e.target.matches('[data-filter-form]')) return;
      e.preventDefault();
      go(e.target);
    });
  };

  const initAccount = () => {
    const recover = $('#RecoverPassword');
    const login = $('#CustomerLogin');
    if (!recover || !login) return;
    const toggle = (show) => {
      recover.hidden = !show;
      login.hidden = show;
    };
    if (window.location.hash === '#recover') toggle(true);
    d.addEventListener('click', (e) => {
      const t = e.target.closest('[data-toggle-recover]');
      if (!t) return;
      e.preventDefault();
      toggle(t.getAttribute('href') === '#recover');
    });
  };

  /* ---------- announcement tape ---------- */
  const initAnnounce = (scope = d) => {
    $$('[data-announce]', scope).forEach((bar) => {
      if (bar.dataset.ready) return;
      bar.dataset.ready = '1';
      const msgs = $$('[data-announce-msg]', bar);
      if (msgs.length < 2) return;
      const secs = Number(bar.dataset.rotate) || 0;
      const calm = motion() === 'calm';
      const pause = $('[data-announce-pause]', bar);
      const arrows = $$('[data-announce-step]', bar);
      let i = Math.max(0, msgs.findIndex((m) => m.classList.contains('is-active')));
      let timer = null;
      let paused = false;
      let hold = false;
      const show = (n) => {
        i = (n + msgs.length) % msgs.length;
        msgs.forEach((m, k) => m.classList.toggle('is-active', k === i));
      };
      const stop = () => {
        clearInterval(timer);
        timer = null;
      };
      const start = () => {
        stop();
        if (secs > 0 && !calm && !paused && !hold) timer = setInterval(() => show(i + 1), secs * 1000);
      };
      if (secs > 0 && calm) {
        if (pause) pause.hidden = true;
        arrows.forEach((a) => (a.hidden = false));
      }
      arrows.forEach((a) => a.addEventListener('click', () => show(i + Number(a.dataset.announceStep))));
      if (pause) {
        pause.addEventListener('click', () => {
          paused = !paused;
          pause.setAttribute('aria-pressed', String(paused));
          const lbl = $('[data-announce-pause-label]', pause);
          if (lbl) lbl.textContent = paused ? S.play : S.pause;
          if (paused) stop();
          else start();
        });
      }
      const holdOn = () => {
        hold = true;
        stop();
      };
      const holdOff = () => {
        hold = false;
        start();
      };
      bar.addEventListener('pointerenter', holdOn);
      bar.addEventListener('pointerleave', holdOff);
      bar.addEventListener('focusin', holdOn);
      bar.addEventListener('focusout', (e) => !bar.contains(e.relatedTarget) && holdOff());
      bar.addEventListener('shopify:block:select', (e) => {
        const k = msgs.indexOf(e.target.closest('[data-announce-msg]'));
        if (k >= 0) show(k);
        holdOn();
      });
      bar.addEventListener('shopify:block:deselect', holdOff);
      start();
    });
  };

  /* ---------- public API ---------- */
  window.AMS = {
    version: '3.0.0',
    settings: cfg,
    strings: S,
    motion,
    money,
    announce,
    layers: { open: openLayer, close: closeLayer },
    quickView,
    initProduct,
    cart
  };
  emit('ams:ready');

  const init = () => {
    initLayers();
    initDetails();
    initMega();
    initPredictive();
    initCart();
    initModals();
    initAutosubmit();
    initAccount();
    initQuickView();
    initLightbox();
    initProduct(d);
    initRecommendations(d);
    initAnnounce(d);
    setHeaderH();
    updateHeader();
    const h = getHeader();
    if (h && 'ResizeObserver' in window) new ResizeObserver(setHeaderH).observe(h);
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', setHeaderH);
    window.addEventListener('pageshow', (e) => {
      if (e.persisted)
        cart
          .get()
          .then((c) => updateCount(c.item_count))
          .catch(() => {});
    });
    d.addEventListener('shopify:section:load', (e) => {
      initProduct(e.target);
      initRecommendations(e.target);
      initAnnounce(e.target);
      bindLightboxes(e.target);
      bindHover(e.target);
      setHeaderH();
    });
    d.addEventListener('shopify:section:select', (e) => {
      if ($('[data-cart-drawer]', e.target)) openLayer(drawer());
    });
    d.addEventListener('shopify:section:deselect', (e) => {
      if ($('[data-cart-drawer]', e.target)) closeLayer(drawer());
    });
  };

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init);
  else init();
})();
